import React from 'react';
import { useEffect } from 'react';
import { Link } from 'gatsby';

//--Components----------------------------------------//
import LayoutHtml__JP0 from '../../../components/htmlBase0/layoutBase0/LayoutHtml__JP0';



//--REACT メイン関数--------------------------------------------------------------//
const gallery: React.FC = () => {

  //--リダイレクト----------------------------------------//
  const signAfter = () => {
    const redirect_url = '/j/guide/summary/';
    location.href = redirect_url;
  }

  //useEffect:第一引数にcallbackを入れて、第二引数に依存する値の配列を入れる
  //          依存する値が変更される度にcallbackが実行される
  useEffect(() => {
    let cleanUp__isMounted = true;

    //--リダイレクト----------------------------------------//
    signAfter();

    const cleanUpIsMounted = () => {
      cleanUp__isMounted = false;
    };
    return cleanUpIsMounted;
  }, []);

  //--各値の設定----------------------------------------//
  //--メタタグ関連 ----------//
  const seo__title = 'マーカーレスAR等の使い方';
  const seo__description = 'マーカーレスAR等の使い方';
  const seo__canonicalUrl = 'https://xrsns.com/j/guide/summary/';
  const seo__imgUrl = 'https://s.xrsns.com/imgMaster/imgXrsns/guide/summary/summary_allInOneJp_0.png';
  const seo__imgWidth = '256';
  const seo__imgHeight = '144';

  //--看板見出し----------//
  const headLine = '使い方 要約＆概要';

  //--パンくずリスト----------//
  const breadList__textA = '';
  const breadList__linkA = '/';
  const breadList__textB = 'その他';
  const breadList__linkB = '/j/other/';
  const breadList__textC = '使い方 要約＆概要';
  const breadList__linkC = '2501NotLink';
  const breadList__textD = '';
  const breadList__linkD = '2501NotFound';
  const breadList__textE = '';
  const breadList__linkE = '2501NotFound';
  const breadList__textF = '';
  const breadList__linkF = '2501NotFound';


  //--return JSX----------------------------------------//
  return (
    <LayoutHtml__JP0
      hierarchy='../../../'
      seo__title={seo__title}
      seo__description={seo__description}
      seo__canonicalUrl={seo__canonicalUrl}
      seo__imgUrl={seo__imgUrl}
      seo__imgWidth={seo__imgWidth}
      seo__imgHeight={seo__imgHeight}
      drawer__updateImg=''
      headLine={headLine}
      breadList__textA={breadList__textA}
      breadList__linkA={breadList__linkA}
      breadList__textB={breadList__textB}
      breadList__linkB={breadList__linkB}
      breadList__textC={breadList__textC}
      breadList__linkC={breadList__linkC}
      breadList__textD={breadList__textD}
      breadList__linkD={breadList__linkD}
      breadList__textE={breadList__textE}
      breadList__linkE={breadList__linkE}
      breadList__textF={breadList__textF}
      breadList__linkF={breadList__linkF}
      sideNavi__color={{background: ''}}
    >

      <h2 className="contentsHeader0">(旧)XRSNSの使い方説明</h2>

      <p className="contentsText0">
        <Link className="aRed0" to="/j/guide/summary/">
          サービス拡大の為にXRSNSの使い方説明のページはこちらに移動しました。
        </Link><br />
        (自動で切り替わります。)
      </p>

      <div className="space0__small0" />
      <div className="space0__small0" />

    </LayoutHtml__JP0>
  )
}

export default gallery;